import { useMemo, useState } from 'react';
import { isEmpty, omit } from 'lodash/fp';
import { IconButton, IconName, Stack } from '@optimus-web/core';
import { ConfirmationDialog, TooltippedSpan, useEnterpriseNavigate } from '@mews-commander/ui';
import { eqUniversal } from '@mews/fp';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useProductChecklistFiltersStorage } from '../utils/useProductChecklistFiltersStorage';
import { ProductCheckListFilterValues } from '../components/panels/ProductCheckListFilterFields/types';

interface Props {
    searchParams: Omit<ProductCheckListFilterValues, 'date'>;
    filtersDefaultValue: ProductCheckListFilterValues;
}
export const ProductCheckListFilterActions = ({ searchParams, filtersDefaultValue }: Props) => {
    const localStorage = useProductChecklistFiltersStorage();
    const [isDialogOpened, setDialogOpened] = useState(false);
    const navigate = useEnterpriseNavigate();

    const openDialog = () => setDialogOpened(true);
    const closeDialog = () => setDialogOpened(false);

    const filtersSaved = useMemo(
        () => isEmpty(searchParams) || eqUniversal.equals(omit('date', filtersDefaultValue), searchParams),
        [filtersDefaultValue, searchParams]
    );

    const handleChange = () => {
        if (!filtersSaved) {
            localStorage.set(searchParams);
            closeDialog();
            void navigate({ to: 'ProductCheckList/Index', search: {} });
        }
    };

    const tooltip = !filtersSaved
        ? lt('ProductCheckListSaveDefaultFiltering')
        : lt('ProductCheckListDefaultFilteringSaved');

    return (
        <>
            <ConfirmationDialog
                confirmationOpened={isDialogOpened}
                textKey={TextKey.ProductChecklistSaveDefaultFiltersDialogTitle}
                cancelChange={closeDialog}
                confirmChange={handleChange}
                confirmButtonTextKey={TextKey.SaveAndApply}
                confirmButtonVariant="primary"
                content={lt('ProductChecklistSaveDefaultFiltersDialogContent')}
            />
            <Stack>
                <TooltippedSpan tooltip={tooltip}>
                    <IconButton
                        variant="secondary"
                        icon={IconName.Stars}
                        disabled={filtersSaved}
                        onClick={openDialog}
                        type="submit"
                    />
                </TooltippedSpan>
            </Stack>
        </>
    );
};
